import * as yup from "yup";

/**
 * Subtitle Speed Settings Validation Schema
 * Validates scroll speed configuration per language (0.1 ~ 2.0)
 */
export const subtitleSpeedSchema = () => {
    return yup.object().shape({
        subtitle_speed: yup.array().of(
            yup.object().shape({
                language: yup.string().required(),
                speed: yup.number().min(0.1, "速度不能小於 0.1").max(2.0, "速度不能大於 2.0").required("速度為必填"),
            })
        ),
    });
};
